import { useCallback, useRef } from 'react';
import { IHandleSetInputParams, TInputState } from '../types';
import { THandleSetInput } from './types';

export const useHandleSetInput = ({
  inputs,
  setInputs,
}: IHandleSetInputParams): THandleSetInput => {
  const inputsRef = useRef(inputs);
  inputsRef.current = inputs;

  return useCallback(
    (name: string, input: TInputState) => {
      setInputs(prev => ({ ...prev, [name]: input }));
    },
    [setInputs]
  );
};
